import type { DeviceChangeActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import { DeviceType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  FieldSet,
  Legend,
  SelectionButton,
  SelectionButtons,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEventHandler } from "react"
import { useCallback } from "react"

import { usePolyglot } from "src/contexts"
import styles from "src/styles/entryModal.module.scss"

const polyglotPrefix = "components.entry_modal.device_change."

interface Props {
  activity?: Partial<DeviceChangeActivity>;
  updateActivity: (a: Partial<DeviceChangeActivity>) => void;
}

const deviceList = [
  DeviceType.CGM,
  DeviceType.InfusionSet,
  DeviceType.InsulinPen,
  DeviceType.GlucoseSensor,
  DeviceType.Transmitter,
  DeviceType.PumpCartridge,
]

export function DeviceTypeRadioButton(props: Props) {
  const {
    activity,
    updateActivity,
  } = props

  const polyglot = usePolyglot()

  const onDeviceTypeChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const newValue = e.target.value as DeviceType

      updateActivity({
        device_type: newValue,
      })
    },
    [updateActivity],
  )

  return (
    <FieldSet id="device-type">
      <Legend
        className={styles.legend}
        sizePreset="small"
      >
        {polyglot.t(`${polyglotPrefix}legend`)}
      </Legend>
      <SelectionButtons>
        {deviceList.map((option) => (
          <SelectionButton
            key={option}
            htmlFor={option}
            value={option}
            name="device_type"
            onChange={onDeviceTypeChange}
            checked={activity?.device_type === option}
            id={"selection-button"}
          >
            {polyglot.t(`device_type.${option}`)}
          </SelectionButton>
        ))}
      </SelectionButtons>

    </FieldSet>
  )
}
